import axios from "axios";

/*
 * JSM DIGITAL SOLUTIONS
 * Central API Configuration
 *
 * Browser production:
 *   /api -> Nginx -> FastAPI :8000
 *
 * Desktop app:
 *   window.jsmDesktop.backendUrl can provide direct backend URL
 */

const BACKEND_URL =
  window.jsmDesktop?.backendUrl ||
  process.env.REACT_APP_BACKEND_URL ||
  "";

export const API = `${BACKEND_URL.replace(/\/+$/, "")}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 30000,
  headers: {
    Accept: "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jsm_token");

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      // Token expired / invalid.
      // AuthContext handles authentication state.
    }

    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;

  if (!detail) {
    return err?.message || "Something went wrong";
  }

  if (typeof detail === "string") {
    return detail;
  }

  if (Array.isArray(detail)) {
    return detail
      .map((item) => item?.msg || JSON.stringify(item))
      .join(" ");
  }

  return String(detail);
}
